module.exports = __webpack_public_path__ + "static/media/not_included.8c480508.svg";